export const environment = {
    production: false,
    stage: 'staging',
    grpcHost: 'https://api002.epicore.dk',
};